import React from 'react'
import { Link } from 'gatsby'
import { useAuth0 } from '@auth0/auth0-react'
import {
  ReaderIcon,
  MixIcon,
  PersonIcon,
  QuestionMarkIcon,
  ExitIcon,
} from '@radix-ui/react-icons'

const toggleMenu = () => {
  const menu = document.getElementById('menu')
  if (menu.classList.contains('open')) {
    setTimeout(toggleHorizontal, 500)
  } else {
    toggleHorizontal()
  }
  menu.classList.toggle('open')
  document.getElementById('toggle').classList.toggle('x')
}

const toggleHorizontal = () => {
  const x = []
  x.forEach.call(
    document.getElementById('menu').querySelectorAll('.custom-can-transform'),
    function (el) {
      el.classList.toggle('pure-menu-horizontal')
    }
  )
}

const clickToggleHandler = (e) => {
  toggleMenu()
  e.preventDefault()
}

const UserProfile = () => {
  const { isAuthenticated, user, loginWithRedirect, logout } = useAuth0()

  const onLogoutClick = (e) => {
    e.preventDefault()
    logout({
      logoutParams: {
        returnTo: process.env.AUTH0_CALLBACK,
      },
    })
  }

  if (isAuthenticated) {
    return (
      <>
        <li className="pure-menu-item">
          <Link to="/account/" className="pure-menu-link">
            <PersonIcon /> 会员中心 ({user.email})
          </Link>
        </li>
        <li className="pure-menu-item">
          <Link to="#" className="pure-menu-link" onClick={onLogoutClick}>
            <ExitIcon /> 退出登录
          </Link>
        </li>
      </>
    )
  }
  return (
    <>
      <li className="pure-menu-item">
        <Link to="#" className="pure-menu-link" onClick={loginWithRedirect}>
          <PersonIcon /> VIP
        </Link>
      </li>
      <li className="pure-menu-item">
        <Link to="/help" className="pure-menu-link">
          <QuestionMarkIcon /> 帮助
        </Link>
      </li>
    </>
  )
}

const Header = ({ siteTitle }) => (
  <div className="header pure-g" id="menu">
    <div className="pure-u-1 pure-u-md-1-3">
      <div className="pure-menu header-title">
        <Link to="/" className="pure-menu-heading custom-brand">
          <img
            src="/assets/images/favicon-96x96.png"
            style={{ height: '30px' }}
            alt={siteTitle}
          />
          <span>{siteTitle}</span>
        </Link>
        <button
          className="custom-toggle"
          id="toggle"
          onClick={clickToggleHandler}
          aria-label="toggle menu"
        >
          <s className="bar" />
          <s className="bar" />
          <s className="bar" />
        </button>
      </div>
    </div>

    <div className="pure-u-1 pure-u-md-1-3">
      <div className="pure-menu pure-menu-horizontal custom-can-transform">
        <ul className="pure-menu-list">
          <li className="pure-menu-item">
            <Link to="/" className="pure-menu-link">
              <ReaderIcon /> 信息
            </Link>
          </li>
          <li className="pure-menu-item">
            <Link to="/ranking" className="pure-menu-link">
              <MixIcon /> 商家
            </Link>
          </li>
          <UserProfile />
        </ul>
      </div>
    </div>
  </div>
)

export default Header
